import debug from 'debug'

export function getLogger(module: string) {
  return debug(`web-player:${module}`)
}
